import type { PaletteOptions } from '@mui/material/styles';
import {
  ACCENT_ERROR,
  ACCENT_INFO,
  BRAND_HEADING_COLOR,
  CARD_SECONDARY_COLOR,
  COMMON_DEFAULT,
  GOLD_HIGHLIGHT,
  GOLD_HIGHLIGHT_LIGHT,
  ICON_COLOR,
  ICON_LIGHT,
  INPUT_TEXT_COLOR,
  LIGHT_ASH,
  MAIN_COLOR,
  OUTLINE_PRIMARY,
  OUTLINE_SECENDARY,
  PRIMARY_COLOR,
  QUATERARY_COLOR,
  SECONDARY_COLOR,
  SHADE_COLOR,
  TERNARY_COLOR,
  TEXT_PRIMARY_COLOR,
  TEXT_SECONDARY_COLOR,
  TEXT_TERNARY_COLOR,
} from './colors';

const palette: PaletteOptions = {
  primary: {
    main: PRIMARY_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  secondary: {
    main: SECONDARY_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  ternary: {
    main: TERNARY_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  heading: {
    main: BRAND_HEADING_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  queternary: {
    main: MAIN_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  quinary: {
    main: QUATERARY_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  error: {
    main: ACCENT_ERROR,
    contrastText: COMMON_DEFAULT,
  },
  info: {
    main: ACCENT_INFO,
    contrastText: COMMON_DEFAULT,
  },
  success: {
    main: PRIMARY_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  disabled: {
    main: SHADE_COLOR,
    contrastText: COMMON_DEFAULT,
  },
  icons: {
    main: ICON_COLOR,
    light: ICON_LIGHT,
    contrastText: COMMON_DEFAULT,
    lightAsh: LIGHT_ASH,
    highlighter: GOLD_HIGHLIGHT,
    highlight: GOLD_HIGHLIGHT_LIGHT,
  },
  text: {
    primary: MAIN_COLOR,
    secondary: ICON_COLOR,
    disabled: MAIN_COLOR,
  },
  divider: SHADE_COLOR,
  background: {
    paper: COMMON_DEFAULT,
    default: SHADE_COLOR,
  },
  common: {
    white: COMMON_DEFAULT,
    black: '#000000',
  },
  cards: {
    main: CARD_SECONDARY_COLOR,
    contrastText: MAIN_COLOR,
  },
  textcolor: {
    main: INPUT_TEXT_COLOR,
    contrastText: MAIN_COLOR,
  },
  buttoncolor: {
    main: OUTLINE_PRIMARY,
    contrastText: OUTLINE_SECENDARY,
  },
  textSecondary: {
    main: TEXT_PRIMARY_COLOR,
    light: TEXT_SECONDARY_COLOR,
    dark: TEXT_TERNARY_COLOR,
  },
};

export default palette;
